import defaultLogo from '/logo.svg';
import { Link } from 'react-router-dom';

interface LogoProps extends React.HTMLAttributes<HTMLImageElement> {
  linkTo?: string;
  src?: string;
}

export function Logo({ className, linkTo, src, ...props }: LogoProps) {
  const base = <img src={src || defaultLogo} alt="Logo" className={className} {...props} />;
  return linkTo ? <Link to={linkTo}>{base}</Link> : base;
}
